import { createTheme } from '@mui/material/styles';

// Importar la fuente en un archivo CSS separado o en el index.html
export const theme = createTheme({
  typography: {
    fontFamily: '"Open Sans", sans-serif',
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#F4F4F4',
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '100%',
          letterSpacing: '0%',
          color: '#000000'
        },
        body: {
          fontWeight: 400,
          fontSize: '10px',
          lineHeight: '100%',
          letterSpacing: '0%'
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: '30px',
          backgroundColor: '#FFFFFF',
          borderRadius: '5px',
          fontWeight: 400,
          fontSize: '10px',
          lineHeight: '100%',
          letterSpacing: '0%',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E6E6E6',
            borderWidth: '1px'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E6E6E6',
            borderWidth: '1px'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E6E6E6',
            borderWidth: '1px'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          height: '30px'
        }
      }
    }
  },
}); 